var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "action-button-host",
      attrs: {
        title:
          _vm.disabled && _vm.disabledReason ? _vm.disabledReason : undefined,
      },
    },
    [
      _c(
        "button",
        {
          staticClass: "action-button",
          attrs: {
            type: "button",
            disabled: _vm.disabled,
            "aria-disabled": _vm.disabled ? "true" : "false",
          },
          on: {
            click: _vm.handleClick,
            keydown: [
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.handleClick.apply(null, arguments)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar",
                  ])
                )
                  return null
                return _vm.handleClick.apply(null, arguments)
              },
            ],
          },
        },
        [
          _c("span", { staticClass: "action-button__text" }, [
            _vm._v(_vm._s(_vm.text)),
          ]),
          _vm.iconSrc
            ? _c(
                "span",
                {
                  staticClass: "action-button__icon",
                  attrs: {
                    role:
                      _vm.iconClickable && !_vm.disabled ? "button" : undefined,
                    tabindex:
                      _vm.iconClickable && !_vm.disabled ? 0 : undefined,
                    "aria-hidden":
                      _vm.iconClickable && !_vm.disabled ? "false" : "true",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.iconClickable &&
                        !_vm.disabled &&
                        _vm.handleIconClick()
                    },
                    keydown: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        $event.stopPropagation()
                        $event.preventDefault()
                        _vm.iconClickable &&
                          !_vm.disabled &&
                          _vm.handleIconClick()
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "space", 32, $event.key, [
                            " ",
                            "Spacebar",
                          ])
                        )
                          return null
                        $event.stopPropagation()
                        $event.preventDefault()
                        _vm.iconClickable &&
                          !_vm.disabled &&
                          _vm.handleIconClick()
                      },
                    ],
                  },
                },
                [_c("img", { attrs: { src: _vm.iconSrc, alt: "" } })]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }